import React, { useEffect, useRef } from "react";

const DynamicTextArea = ({
	value,
	onChange,
	minRows = 2,
	maxRows = 50,
	placeholder,
	className = "",
	style = {},
	id
}) => {

	const textareaRef = useRef(null);

	useEffect(() => {
		const el = textareaRef.current;
		if (!el) return;

		el.style.height = "auto";
		const scrollHeight = el.scrollHeight;

		if (maxRows) {
			const lineHeight = parseFloat(window.getComputedStyle(el).lineHeight);
			const maxHeight = lineHeight * maxRows;
			el.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
		} else {
			el.style.height = `${scrollHeight}px`;
		}
	}, [value, maxRows]);


	return (
		<textarea
			id={id}
			ref={textareaRef}
			value={value}
			onChange={(e) => onChange(e.target.value)}
			rows={minRows}
			placeholder={placeholder}
			style={{
				resize: "none",
				overflow: "hidden",
				...style
			}}
			className={className}
		/>
	);
};

export default DynamicTextArea;